import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["id"]

import {
		inject,
	} from "vue"

	
	const __default__ = { name: 'VDatalist' } // name the component

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
		id: {
			type: String,
			default: ''
		}
	},
  setup(__props) {

const props = __props;

	

	const controlId: string = inject('controlId', null) || props.id

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("datalist", {
    id: 'list-' + _unref(controlId) ?? undefined
  }, [
    _renderSlot(_ctx.$slots, "default")
  ], 8, _hoisted_1))
}
}

})